// import React from "react";
// import { BookOpen, Users, Zap, Award, ArrowRight } from "lucide-react";
import { Play } from "lucide-react";
import "../../styles/cmyuva.css";

const CmYuvaBenefits = () => {
  // const benefits = [
  //   {
  //     icon: <BookOpen size={32} />,
  //     title: "Comprehensive Training",
  //     description: "Industry-curated curriculum covering storytelling, content creation, and immersive technologies."
  //   },
  //   {
  //     icon: <Users size={32} />,
  //     title: "Expert Mentorship",
  //     description: "Direct guidance from industry veterans to navigate India's fragmented creative landscape."
  //   },
  //   {
  //     icon: <Zap size={32} />,
  //     title: "Real Projects",
  //     description: "GigMedia platform connects you directly with agencies and brands for live projects."
  //   },
  //   {
  //     icon: <Award size={32} />,
  //     title: "Industry Recognition",
  //     description: "Transform your skills into a recognized career in the creative ecosystem."
  //   }
  // ];

  const benefits = [
    "CM Yuva Scheme-aligned, low-investment business model",
    "Earn-while-you-learn execution framework",
    "Ready market linkage through HKI Media & GigMedia",
    "Continous work& Client acquisition from GigMedia App",
    "Scalable model with district and state-level expansion",
    "Training, SOPS, Pipeline development as per international standards and ongoing Operational Support",
    "Work across Advertising, Content Creation, Events, Films, Music Video, Marketing etc",
    "Opportunity to become skilled technician with continuous upskilling workshops from Bollywood veterans.",
  ];

  return (
    <section className="cmyuva_benefits_section bg-gradient-to-b from-[#0a0a0a] via-[#0f172a] to-[#0a0a0a] py-5">
      <div className="container py-4">
        <div className="text-center mb-3" data-aos="fade-up">
          {/* <span className="text-uppercase text-danger fw-bold letter-spacing-2">Why Join Us</span> */}
          {/* <h2 className="cmyuva_section_title m-4">How CM Yuva Helps You</h2> */}
          <h2 className="cmyuva_section_title m-4">
            Why HKI Digital Media Studio
          </h2>
        </div>

        {/* ADDED THESE POINTS AND ARCHIVED THE BENEFIT CARDS */}
        <div className="row g-4" data-aos="fade-up">
          {/* <div className="row"></div> */}
          <div class="cmyuva_info_card col-lg-6" data-aos="fade-right">
            <div class="cmyuva_about_paragraph">
              {benefits.map((benefit, id) =>
                id >= 4 ? null : (
                  // <div key={id}>
                  //   <li className="bp bp-play">
                  //     <span className="bp-icon">
                  //       <Play size={14} strokeWidth={2} />
                  //     </span>
                  //     <span>{benefit}</span>
                  //   </li>
                  // </div>
                  <div key={id} className="">
                    <div className="benefit-card d-flex align-items-center m-4">
                      <div className="benefit-icon">
                        <span className="dot"></span>
                      </div>
                      <div className="benefit-content">{benefit}</div>
                    </div>
                  </div>
                ),
              )}
            </div>
          </div>
          <div className="col-lg-6" data-aos="fade-left">
            {/* <span>image</span> */}
            {benefits.map((benefit, id) =>
              id < 4 ? null : (
                                  <div key={id} className="">
                    <div className="benefit-card d-flex align-items-center m-4">
                      <div className="benefit-icon">
                        <span className="dot"></span>
                      </div>
                      <div className="benefit-content">{benefit}</div>
                    </div>
                  </div>
              ),
            )}
            <img loading="lazy" decoding="async" />
          </div>
          {/* {benefits.map((benefit, idx) => (
            <div key={idx} className="col-lg-3 col-md-6" data-aos="fade-up" data-aos-delay={idx * 100}>
              <div className="cmyuva_benefit_card h-100 d-flex flex-column">
                <div className="cmyuva_benefit_icon mb-4 text-danger bg-danger-subtle p-3 rounded-circle d-inline-block" style={{width: 'fit-content'}}>
                  {benefit.icon}
                </div>
                <h4 className="fw-bold mb-3 h5">{benefit.title}</h4>
                <p className="text-gray-300 flex-grow-1 mb-4">{benefit.description}</p>
                <div className="mt-auto">
                  <a href="#" className="text-danger text-decoration-none fw-semibold d-inline-flex align-items-center group-hover">
                    Learn more <ArrowRight size={16} className="ms-2 transition-transform" />
                  </a>
                </div>
              </div>
            </div>
          ))} */}
        </div>
      </div>
    </section>
  );
};

export default CmYuvaBenefits;
